/**
 * PrimeVue locale configuration using i18n translations.
 */

export type Translator = (key: string, params?: Record<string, unknown>) => string

export const createPrimeVueLocale = (t: Translator) => ({
  startsWith: t('Começa com'),
  contains: t('Contém'),
  notContains: t('Não contém'),
  endsWith: t('Termina com'),
  equals: t('Igual a'),
  notEquals: t('Diferente de'),
  noFilter: t('Sem filtro'),
  filter: t('Filtrar'),
  lt: t('Menor que'),
  lte: t('Menor ou igual a'),
  gt: t('Maior que'),
  gte: t('Maior ou igual a'),
  dateIs: t('Data é'),
  dateIsNot: t('Data não é'),
  dateBefore: t('Data antes de'),
  dateAfter: t('Data depois de'),
  custom: t('Personalizado'),
  clear: t('Limpar'),
  apply: t('Aplicar'),
  matchAll: t('Corresponder a todos'),
  matchAny: t('Corresponder a qualquer'),
  addRule: t('Adicionar regra'),
  removeRule: t('Remover regra'),
  accept: t('Sim'),
  reject: t('Não'),
  choose: t('Escolher'),
  upload: t('Enviar'),
  cancel: t('Cancelar'),
  completed: t('Concluído'),
  pending: t('Pendente'),
  dayNames: [
    t('Domingo'), t('Segunda-feira'), t('Terça-feira'), t('Quarta-feira'),
    t('Quinta-feira'), t('Sexta-feira'), t('Sábado')
  ],
  dayNamesShort: [
    t('Dom'), t('Seg'), t('Ter'), t('Qua'), t('Qui'), t('Sex'), t('Sáb')
  ],
  dayNamesMin: [
    t('D'), t('S'), t('T'), t('Q'), t('Q'), t('S'), t('S')
  ],
  monthNames: [
    t('Janeiro'), t('Fevereiro'), t('Março'), t('Abril'), t('Maio'), t('Junho'),
    t('Julho'), t('Agosto'), t('Setembro'), t('Outubro'), t('Novembro'), t('Dezembro')
  ],
  monthNamesShort: [
    t('Jan'), t('Fev'), t('Mar'), t('Abr'), t('Mai'), t('Jun'),
    t('Jul'), t('Ago'), t('Set'), t('Out'), t('Nov'), t('Dez')
  ],
  chooseYear: t('Escolher ano'),
  chooseMonth: t('Escolher mês'),
  chooseDate: t('Escolher data'),
  prevDecade: t('Década anterior'),
  nextDecade: t('Próxima década'),
  prevYear: t('Ano anterior'),
  nextYear: t('Próximo ano'),
  prevMonth: t('Mês anterior'),
  nextMonth: t('Próximo mês'),
  prevHour: t('Hora anterior'),
  nextHour: t('Próxima hora'),
  prevMinute: t('Minuto anterior'),
  nextMinute: t('Próximo minuto'),
  prevSecond: t('Segundo anterior'),
  nextSecond: t('Próximo segundo'),
  am: t('AM'),
  pm: t('PM'),
  today: t('Hoje'),
  weekHeader: t('Sem'),
  firstDayOfWeek: 0,
  dateFormat: 'dd/mm/yy',
  weak: t('Fraco'),
  medium: t('Médio'),
  strong: t('Forte'),
  passwordPrompt: t('Digite uma senha'),
  emptyFilterMessage: t('Nenhum resultado encontrado'),
  searchMessage: t('{0} resultados disponíveis'),
  selectionMessage: t('{0} itens selecionados'),
  emptySelectionMessage: t('Nenhum item selecionado'),
  emptySearchMessage: t('Nenhum resultado encontrado'),
  emptyMessage: t('Nenhuma opção disponível'),
  aria: {
    trueLabel: t('Verdadeiro'),
    falseLabel: t('Falso'),
    nullLabel: t('Não selecionado'),
    star: t('1 estrela'),
    stars: t('{star} estrelas'),
    selectAll: t('Todos os itens selecionados'),
    unselectAll: t('Todos os itens desmarcados'),
    close: t('Fechar'),
    previous: t('Anterior'),
    next: t('Próximo'),
    navigation: t('Navegação'),
    scrollTop: t('Rolar para o topo'),
    moveTop: t('Mover para o topo'),
    moveUp: t('Mover para cima'),
    moveDown: t('Mover para baixo'),
    moveBottom: t('Mover para baixo'),
    moveToTarget: t('Mover para o destino'),
    moveToSource: t('Mover para a origem'),
    moveAllToTarget: t('Mover tudo para o destino'),
    moveAllToSource: t('Mover tudo para a origem'),
    firstPageLabel: t('Primeira página'),
    lastPageLabel: t('Última página'),
    nextPageLabel: t('Próxima página'),
    prevPageLabel: t('Página anterior'),
    rowsPerPageLabel: t('Linhas por página'),
    jumpToPageDropdownLabel: t('Ir para a página'),
    jumpToPageInputLabel: t('Ir para a página'),
    selectRow: t('Linha selecionada'),
    unselectRow: t('Linha desmarcada'),
    expandRow: t('Linha expandida'),
    collapseRow: t('Linha recolhida'),
    showFilterMenu: t('Mostrar menu de filtro'),
    hideFilterMenu: t('Ocultar menu de filtro'),
    filterOperator: t('Operador de filtro'),
    filterConstraint: t('Restrição de filtro'),
    editRow: t('Editar linha'),
    saveEdit: t('Salvar edição'),
    cancelEdit: t('Cancelar edição'),
    listView: t('Visualização em lista'),
    gridView: t('Visualização em grade'),
    slide: t('Slide'),
    zoomImage: t('Ampliar imagem'),
    zoomIn: t('Ampliar'),
    zoomOut: t('Reduzir'),
    rotateRight: t('Girar à direita'),
    rotateLeft: t('Girar à esquerda')
  }
})
